export enum AttachmentType {
    JOB_PICTURE = 'JOB_PICTURE',
    AVATAR_PICTURE = 'AVATAR_PICTURE',
    ADDITIONAL_ITEM_PICTURE = 'ADDITIONAL_ITEM_PICTURE'
}



// WEBPACK FOOTER //
// ./src/types/enums/AttachmentType.ts